import React, { useEffect } from "react";
import { ReactNode, useState } from "react";
import { createContext } from "react";
import useAuthData from "../../../hook/useAppData";
import { orderBy } from "../../../libs/orderBy";
import { orderByName } from "../../../libs/orderList";
import { serviceUsers } from "../../Collaborator/service";
import { service } from "../../Project/service/service";
import { StoreContextProps, StoreProviderProps } from "../model";
import { serviceHistory } from "../service";

export const HistoryContext = createContext({} as StoreContextProps);

export function HistoryContextProvider({ children }: StoreProviderProps) {
  const { token } = useAuthData();

  const [filterProject, setFilterProject] = useState(0);
  const [filterCollaborator, setFilterCollaborator] = useState(0);
  const [listProject, setListProject] = useState([] as any[]);
  const [listUsers, setListUsers] = useState([]);

  const [listRender, setListRender] = useState([] as any[]);
  const [listGroupedHistory, setListGroupedHistory] = useState([] as any[]);

  const [listUsersFilter, setListUsersFilter] = useState([]);

  const [needSpinner, setNeedSpinner] = useState(true);
  const [needModal, setNeedModal] = useState(0);

  const [page, setPage] = useState(0);
  const [selectSize, setSelectSize] = useState(10);
  const [orderSwitch, setOrderSwitch] = useState(true);
  const [originListHistoy, setOriginListHistoy] = useState([] as any[]);

  useEffect(() => {
    getListUsers();
    getListProjects();
    getOriginHistory();
    getHistory();
  }, []);

  useEffect(() => {
    renderizar();
  }, [listRender, listUsers]);

  useEffect(() => {
    setTimeout(() => {
      if (listRender?.length && listGroupedHistory?.length) return setNeedSpinner(false);
      setTimeout(() => {
        return setNeedSpinner(false);
      }, 1500);
    }, 300);
  }, [listRender, listGroupedHistory]);

  function renderizar() {
    const data = listUsers?.map((user: any) => {
      const obj = listRender?.map((datarender: any) => {
        if (user?.id === datarender?.user_id) return datarender;
      });
      return obj;
    });
    const dataMap = data?.map((dataArr: any) => dataArr?.filter(Boolean));
    const dataMapFilter = dataMap?.map((objMap: any) => !!objMap?.length && objMap)?.filter(Boolean);
    const newList = dataMapFilter?.map((listHistory) => listHistory[0]);
    const orderListHistoryByDate = orderBy(newList, "created_at", "desc");
    setListGroupedHistory(orderListHistoryByDate);
  }

  async function getHistory(queryString?: string) {
    const data = await serviceHistory.getHistory(token, queryString && queryString);

    setListRender(data);
  }

  async function getOriginHistory(queryString?: string) {
    const data = await serviceHistory.getHistory(token, queryString && queryString);
    setOriginListHistoy(data);
  }

  function handleOrderListByTH(label: string, labelOfObject: string = undefined) {
    const orderListByDecreasing = orderSwitch && orderBy(listGroupedHistory, label, "desc", labelOfObject && labelOfObject);
    const orderListByCrescent = !orderSwitch && orderBy(listGroupedHistory, label, "asc", labelOfObject && labelOfObject);
    orderSwitch ? setListGroupedHistory(orderListByDecreasing) : setListGroupedHistory(orderListByCrescent);
    setOrderSwitch((oldState) => !oldState);
    setPage(0);
  }

  async function getListUsers() {
    const data = await serviceUsers.getUsers(token);
    setListUsersFilter(data);
    setListUsers(data);
  }

  function getListProjects() {
    service.getProjects(token)?.then(async (data: any) => {
      const orderListFilterUsers = await orderByName(data, "name");
      setListProject(orderListFilterUsers);
    });
  }

  return (
    <HistoryContext.Provider
      value={{
        filterProject,
        setFilterProject,
        filterCollaborator,
        setFilterCollaborator,
        listProject,
        setListProject,
        listUsers,
        setListUsers,
        page,
        setPage,
        selectSize,
        setSelectSize,
        needSpinner,
        setNeedSpinner,
        listRender,
        setListRender,
        listGroupedHistory,
        setListGroupedHistory,
        getHistory,
        listUsersFilter,
        needModal,
        setNeedModal,
        handleOrderListByTH,
      }}
    >
      {children}
    </HistoryContext.Provider>
  );
}
